export default "__VITE_ASSET__c2864089__"